import { Stack } from "@mantine/core"
import { useDebouncedValue } from "@mantine/hooks"
import { PaginationState } from "@tanstack/react-table"
import { DEFAULT_PAGE_SIZE } from "@tfg/ui"
import { useEffect, useState } from "react"

import { DataFetchWrapper } from "~/components/DataFetchWrapper"
import { ProductsLCATable } from "~/pages/Brand/Regulations/LCA/ProductsLCATable.tsx"
import { useFindProductsLcasQuery } from "~/pages/Brand/Regulations/LCA/hooks/useFindProductLcasQuery.ts"

export const ProductsLCAWrapper = () => {
  const [searchProduct, setSearchProduct] = useState<string>()
  const [statusFilter, setStatusFilter] = useState<string | null>(null)

  const [debouncedProduct] = useDebouncedValue<string | undefined>(
    searchProduct,
    600
  )

  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: 0,
    pageSize: DEFAULT_PAGE_SIZE,
  })

  useEffect(() => {
    setPagination((prev) => ({
      ...prev,
      pageIndex: 0,
    }))
  }, [debouncedProduct])

  const productsQuery = useFindProductsLcasQuery({
    params: {
      fetchDataOptions: {
        pageIndex: pagination.pageIndex,
        pageSize: pagination.pageSize,
      },
      searchProduct: debouncedProduct,
      filters: {
        status: statusFilter ?? undefined,
      },
    },
  })

  return (
    <Stack>
      <DataFetchWrapper query={productsQuery}>
        {({ data, isFetching }) => (
          <Stack>
            <ProductsLCATable
              data={data}
              isFetching={isFetching}
              fetchDataOptions={pagination}
              setPagination={setPagination}
              searchProduct={searchProduct}
              setSearchProduct={setSearchProduct}
              statusFilter={statusFilter}
              setStatusFilter={setStatusFilter}
            />
          </Stack>
        )}
      </DataFetchWrapper>
    </Stack>
  )
}
